export default "__VITE_ASSET__Cjeb_aZ9__"